import React from 'react';

export default function WhatsAppFloat() {
  return (
    <div className="wa-float" aria-label="WhatsApp contact">
      <div className="wa-float-tip" aria-hidden="true">Chat on WhatsApp</div>
      <a
        href="https://wa.me/918123629993?text=Hi JSDevBrains, I'd like to discuss a project"
        target="_blank"
        rel="noopener noreferrer"
        className="wa-float-btn"
        aria-label="Open WhatsApp chat with JSDevBrains"
      >
        💬
      </a>
    </div>
  );
}
